<script setup lang="ts">
import CanvasSettingsState from "@/stores/CanvasSettingsState";
import SizeMenu from "./SizeMenu.vue";
import type { ScaleConfig } from "@/types/legend.types";
import { Logger } from "@/logger";
import NoteMenuState from "@/stores/NoteMenuState";
import ScaleMenuState from "@/stores/ScaleMenuState";
import ScaleItem from "./ScaleItem.vue";
import SettingsSelectItem from "./SettingsSelectItem.vue";
import { trackTab } from "@/analytics/drawing-analytics";

function activateScale(scale: ScaleConfig) {
  Logger.info(`ScaleMenu.vue : Activating scale ${JSON.stringify(scale)}`);
  trackTab("settings", "scale_changed", { scale: scale.name });
  ScaleMenuState.selectScale(scale);
  NoteMenuState.updateComputedNoteConfig();
  CanvasSettingsState.updateAndPersist();
}
</script>

<template>
  <div class="btn-group dropdown">
    <SettingsSelectItem
      :title="$t('canvas:settings.scale.title')"
      :label="ScaleMenuState.activeScale?.name"
    />

    <ul
      class="dropdown-menu dropdown-menu-dark w-100"
      style="max-height: 60vh; overflow-y: auto"
    >
      <li>
        <h6 class="dropdown-header">
          {{ $t("canvas:settings.scale.dropdownHeader") }}
        </h6>
      </li>
      <li
        v-for="scale in ScaleMenuState.scales"
        :key="scale.name"
        @click="activateScale(scale)"
      >
        <ScaleItem
          :scale="scale"
          :active-scale="ScaleMenuState.activeScale"
          :forced-size="
            ScaleMenuState.hasForcedSize() ? ScaleMenuState.forcedSize : ''
          "
        />
      </li>
      <SizeMenu />
    </ul>
  </div>
</template>
